import React from 'react'
import {
  Box,
  Display,
  withCitrusTheme,
  Image as CitrusImage,
  Text,
  FontWeight,
  AlignItems,
  JustifyContent,
  Color,
} from '@gousto-internal/citrus-react'
import { Recipe } from '@library/menu-service'
import { getDefaultImage, getMoodImage, getSrcSet } from '../../../utils/formatters'

const ContainedImage = withCitrusTheme(CitrusImage, () => ({
  objectFit: 'contain',
  objectPosition: 'center',
  borderRadius: '3px',
}))

type RecipeProps = {
  recipe: Recipe
}

export const RecipeItem = ({ recipe }: RecipeProps) => {
  const isUnavailable = !recipe.isAvailable
  const image = getMoodImage(recipe.images)

  return (
    <Box
      key={recipe.id}
      display={Display.Flex}
      justifyContent={JustifyContent.FlexStart}
      alignItems={AlignItems.Center}
      gap={3}
      color={Color.ColdGrey_900}
      style={{ opacity: isUnavailable ? 0.3 : 1 }}
    >
      <ContainedImage
        alt={recipe.name}
        loading="lazy"
        src={getDefaultImage(image)}
        srcSet={getSrcSet(image)}
        height="70px"
        width="70px"
      />
      <Box display={Display.Flex} alignItems={AlignItems.Center} flexGrow={1} width="100px">
        <Text fontWeight={FontWeight.Bold}>{recipe.name}</Text>
      </Box>
    </Box>
  )
}
